export default {"src":"/_next/static/media/sushi.f933e32c.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};